interface SentenceLoaderProps {
  ariaId: string;
}

export function SentenceLoader({ ariaId: ariaId }: SentenceLoaderProps) {
  return (
    <div role='status' aria-labelledby={ariaId} data-cbtrack-comp='apricot-vanilla:loader'>
      <div className='cb-loader-shimmer cb-loader-light'>
        <div id={ariaId} role='img' aria-label='Loading content...'>
          <div className='cb-margin-top-4 cb-margin-sm-bottom-8 cb-margin-bottom-4 cb-line-16'></div>
        </div>
      </div>
    </div>
  );
}
